import { Box, withStyles } from '@material-ui/core';

export const ChartContainerBox = withStyles(({ spacing }) => ({
  root: {
    overflowX: 'auto',
    marginBottom: spacing(2),
  },
}))(Box);
